export const strings = {
	chooseDeity: 'Choose your deity',
	saveButton: 'Save',
	newGame: 'New Game',
	clearAllButton: 'Clear All',
	drawButton: 'Draw',
	reverseButton: 'Reverse',
	dismissButton: 'Dismiss',
	flipButton: 'Flip',
	heading: 'Woad',
	handTitle: 'Hand',
	spreadTitle: 'Spread',
	deityCardsTitle: 'Deity Cards',
	finaleDeckTitle: 'Finale Deck',
	toggleFinaleDeck: 'Toggle Finale Deck'
};
